import React, { Suspense } from "react";
import { versions } from "../../util/constants";
import { getVersion } from "../../util/getVersion";
import LoadingScreen from "../../views/LoadingScreen";
import { HotspotsTab } from "../HotspotsTab/HotspotsTab";
import { Island } from "../Island/Island";
import { getIsEmbedded } from "../../util/params";

const StaticImageSpecificControls = React.lazy(() =>
  import("../StaticImageSpecificControls/StaticImageSpecificControls")
);

export function ControlPanel(props) {
  const { className, style } = props;
  const version = getVersion();

  return (
    <div
      className={className}
      style={{
        display: "flex",
        flexDirection: "column",
        ...style,
        // maxHeight: "100%",
        height: getIsEmbedded() ? "100vh" : "calc(100vh - 64px)", // 64px is Toolbar height
        boxSizing: "border-box",
      }}
    >
      <Island
        style={{
          marginBlock: "0.5rem",
          overflowY: "auto",
          flex: "1",
          boxSizing: "border-box",
        }}
      >
        <HotspotsTab />
      </Island>

      {versions.image === version ? (
        <Suspense fallback={<LoadingScreen />}>
          <StaticImageSpecificControls />
        </Suspense>
      ) : null}
    </div>
  );
}
